
(function () {

  function normalize(str) {
    if (typeof str !== 'string') return '';
    return str
      .toLowerCase()
      .replace(/[,.\-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * Find collection by vendor: exact title match first, then normalized match.
   * @param {string} vendor - Product vendor name
   * @param {Array<{title: string, handle: string}>} collections - List of { title, handle }
   * @returns {{ handle: string } | null}
   */
  function findCollectionForVendor(vendor, collections) {
    if (!vendor || !Array.isArray(collections) || collections.length === 0) return null;

    var vendorTrimmed = vendor.trim();
    var vendorNormalized = normalize(vendorTrimmed);

    for (var i = 0; i < collections.length; i++) {
      if (collections[i].title === vendorTrimmed) {
        return { handle: collections[i].handle };
      }
    }

    for (var j = 0; j < collections.length; j++) {
      if (normalize(collections[j].title) === vendorNormalized) {
        return { handle: collections[j].handle };
      }
    }

    return null;
  }

  /**
   * Apply collection link or plain text to a single producer block.
   * @param {HTMLElement} container - .product__producer element
   * @param {string} vendor - Product vendor
   * @param {Array<{title: string, handle: string}>} collections
   */
  function applyProducerLink(container, vendor, collections) {
    var linkEl = container.querySelector('.producer__link, .producer__text');
    if (!linkEl) return;

    var found = findCollectionForVendor(vendor, collections);

    if (found) {
      linkEl.href = '/collections/' + found.handle;
      linkEl.removeAttribute('data-producer-plain');
    } else {
      var span = document.createElement('span');
      span.className = 'producer__text';
      span.setAttribute('data-producer-plain', 'true');
      span.textContent = vendor;
      if (linkEl.parentNode) {
        linkEl.parentNode.replaceChild(span, linkEl);
      }
    }
  }

  function init() {
    var scriptEl = document.getElementById('ProducerCollectionsData');
    if (!scriptEl || scriptEl.type !== 'application/json') return;

    var collections;
    try {
      collections = JSON.parse(scriptEl.textContent || '[]');
    } catch (e) {
      return;
    }

    var producers = document.querySelectorAll('.product__producer[data-product-vendor]');
    for (var i = 0; i < producers.length; i++) {
      var vendor = producers[i].getAttribute('data-product-vendor');
      if (vendor) {
        applyProducerLink(producers[i], vendor, collections);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
